$(function () {
  $.each($('.paginate__textfield'), function (index, item) {
    $(item).on('keypress', function (ev) {
      if (ev.which == 13) {
        var page = $(ev.target).val().trim();
        window.location.href = $(ev.target).attr('data-href') + page;
      }
    });
  });
});
